import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';
import { canUseDOM } from '@swf/core/utils';

const RamAccount: React.FC = () => {
  const requireJSUrl = useResolver(ResolverTag.RamUtils);
  const ramUrl = useResolver(ResolverTag.RamConfig);
  const requireJSScript = useRef<HTMLScriptElement>();
  const ramScript = useRef<HTMLScriptElement>();
  const host = useSelector(select.location.getHost);
  const [requireLoaded, setRequireLoaded] = useState(canUseDOM && !!window.require);

  useEffect(
    () => () => {
      if (requireJSScript.current) {
        requireJSScript.current.remove();
      }
      if (ramScript.current) {
        ramScript.current.remove();
      }
    },
    []
  );

  const scriptTagHandler = (scriptTags: HTMLScriptElement[]) => {
    if (scriptTags) {
      scriptTags.forEach((script) => {
        if (script.src === requireJSUrl) {
          requireJSScript.current = script;
          script.onload = (e) => {
            setRequireLoaded(true);
          };
        }

        if (script.src === ramUrl) {
          ramScript.current = script;
        }
      });
    }
  };

  return (
    <>
      {!requireLoaded && (
        <Helmet
          script={[{ src: requireJSUrl, type: 'text/javascript', 'data-ot-ignore': '' }]}
          // https://github.com/nfl/react-helmet-async/issues/146
          onChangeClientState={(newState, { scriptTags }) => scriptTagHandler(scriptTags)}
        />
      )}
      {/* https://github.com/nfl/react-helmet-async/issues/419 */}
      {requireLoaded && (
        <Helmet
          script={[
            { src: ramUrl, type: 'text/javascript', 'data-ot-ignore': '' },
            {
              type: 'text/javascript',
              innerHTML: `window.ps =  Object.assign(window.ps || {}, {ram : { baseUrl: "https://ram.${host.replace(
                /www\./,
                ''
              )}" } })`
            }
          ]}
          onChangeClientState={(newState, { scriptTags }) => scriptTagHandler(scriptTags)}
        />
      )}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <rg-account className="ng-app:ram" />
    </>
  );
};
export default RamAccount;
